import type { ReactNode } from "react";
import type { HydratedImage } from "../generated/api/types.gen";
import { ImageSelector } from "./ImageSelector";

function DisplayShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex-1 flex flex-col gap-6 min-h-0 relative">
      {children}
    </div>
  );
}

// ── ImageSelectorDisplay ──────────────────────────────────────────────────────
// Used by the results page to show the image grid and enter refinement mode.

interface ImageSelectorDisplayProps {
  images: HydratedImage[];
  selectedImageIndex: number | null;
  isRegenerating: boolean;
  isInitialLoading: boolean;
  onSelectImage: (index: number) => void;
  onEnterRefinementMode: (index: number) => void;
}

export function ImageSelectorDisplay({
  images,
  selectedImageIndex,
  isRegenerating,
  isInitialLoading,
  onSelectImage,
  onEnterRefinementMode,
}: ImageSelectorDisplayProps) {
  return (
    <DisplayShell>
      <ImageSelector
        images={images}
        selectedImageIndex={selectedImageIndex}
        isRegenerating={isRegenerating}
        isInitialLoading={isInitialLoading}
        onSelectImage={onSelectImage}
        onEnterRefinementMode={onEnterRefinementMode}
      />
    </DisplayShell>
  );
}
